import type { SVGProps } from 'react';

const Dollar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_648_11334)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10 0C15.5232 0 20 4.47676 20 10C20 15.5232 15.5232 20 10 20C4.47676 20 0 15.5232 0 10C0 4.47676 4.47676 0 10 0Z"
        fill="#1199FA"
      />
      <path
        d="M9.288 16.6V15.16C7.69867 15.0427 6.456 14.488 5.56 13.496L6.6 12.056C7.336 12.8453 8.232 13.32 9.288 13.48V10.392C8.78667 10.264 8.37067 10.1413 8.04 10.024C7.70933 9.896 7.36267 9.72 7 9.496C6.63733 9.26133 6.36 8.96267 6.168 8.6C5.98667 8.22667 5.896 7.78933 5.896 7.288C5.896 6.46667 6.20533 5.768 6.824 5.192C7.44267 4.616 8.264 4.28533 9.288 4.2V2.712H10.568V4.216C11.8587 4.35467 12.9307 4.83467 13.784 5.656L12.712 7.048C12.1253 6.472 11.4107 6.09867 10.568 5.928V8.68C10.9627 8.78667 11.2987 8.888 11.576 8.984C11.8533 9.08 12.1573 9.21867 12.488 9.4C12.8293 9.57067 13.1013 9.76267 13.304 9.976C13.5067 10.1787 13.6773 10.4453 13.816 10.776C13.9547 11.1067 14.024 11.48 14.024 11.896C14.024 12.7707 13.7307 13.512 13.144 14.12C12.568 14.7173 11.7093 15.064 10.568 15.16V16.6H9.288ZM11.736 12.968C11.992 12.7013 12.12 12.4027 12.12 12.072C12.12 11.7413 11.9867 11.4747 11.72 11.272C11.4533 11.0587 11.0693 10.8773 10.568 10.728V13.496C11.0907 13.4107 11.48 13.2347 11.736 12.968ZM7.816 7.16C7.816 7.672 8.30667 8.06667 9.288 8.344V5.848C8.82933 5.89067 8.46667 6.03467 8.2 6.28C7.944 6.51467 7.816 6.808 7.816 7.16Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_648_11334">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Dollar;
